import env from '../../../env';
import { AppClientId } from '../../Shared/constants';
import * as VehicleDetailsColumns1 from '../installations/1/pages/detailsColumns';
import * as VehicleDetailsColumns2 from '../installations/2/pages/detailsColumns';
import * as VehicleDetailsColumns3 from '../installations/3/pages/detailsColumns';
import * as VehicleDetailsColumns4 from '../installations/4/pages/detailsColumns';
import * as VehicleDetailsColumns6 from '../installations/6/pages/detailsColumns';
import * as VehicleDetailsColumns7 from '../installations/7/pages/detailsColumns';
import * as VehicleDetailsColumns13 from '../installations/13/pages/detailsColumns';
let installationFile;

switch (env.clientId) {
  case AppClientId.INDEWAL:
    installationFile = VehicleDetailsColumns1;
    break;
  case AppClientId.IDWLEASE:
    installationFile = VehicleDetailsColumns1;
    break;
  case AppClientId.HARRY_NIJBOER:
    installationFile = VehicleDetailsColumns2;
    break;
  case AppClientId.HOOIKAMMER:
    installationFile = VehicleDetailsColumns3;
    break;
  case AppClientId.IDW_GMBH:
    installationFile = VehicleDetailsColumns4;
    break;
  case AppClientId.AUTOWIENTJES:
    installationFile = VehicleDetailsColumns6;
    break;
  case AppClientId.AUTOHUISSALLAND:
    installationFile = VehicleDetailsColumns7;
    break;
  case AppClientId.HILTERMANN:
    installationFile = VehicleDetailsColumns13;
    break;
  default:
    installationFile = VehicleDetailsColumns1;
    break;
}

export const VehicleDetailsColumns = installationFile.VehicleDetailsColumns;
